import { render, staticRenderFns } from "./policy.vue?vue&type=template&id=a1daac70&scoped=true&"
var script = {}
import style0 from "./policy.vue?vue&type=style&index=0&id=a1daac70&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1daac70",
  null
  
)

export default component.exports